import { useEffect } from 'react';

const SEOSchema = () => {
  useEffect(() => {
    // Local Business Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://aaronchoi.co.uk/#localbusiness",
      "name": "Aaron Choi Personal Training",
      "image": "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/dhq3wh3j_IMG_3449.JPG",
      "description": "Expert personal trainer in Hampshire offering customized fitness programs, sports massage therapy, seminars, and wellness retreats. BSc Sport and Exercise Science qualified with Level 3 Personal Training certification.",
      "url": "https://aaronchoi.co.uk",
      "telephone": "+447787166065",
      "email": "Aaronchoi@acwellnessanddevelopment.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Hampshire",
        "addressRegion": "Hampshire",
        "addressCountry": "GB"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 50.8198,
        "longitude": -1.0880
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Southampton"
        },
        {
          "@type": "City",
          "name": "Portsmouth"
        },
        {
          "@type": "City",
          "name": "Winchester"
        },
        {
          "@type": "City",
          "name": "Basingstoke"
        },
        {
          "@type": "City",
          "name": "Eastleigh"
        },
        {
          "@type": "City",
          "name": "Fareham"
        },
        {
          "@type": "City",
          "name": "Andover"
        },
        {
          "@type": "City",
          "name": "Fleet"
        }
      ],
      "priceRange": "££",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "06:00",
          "closes": "21:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Saturday"],
          "opens": "08:00",
          "closes": "18:00"
        }
      ],
      "sameAs": [
        "https://www.instagram.com/aaronchoi",
        "https://www.facebook.com/aaronchoi",
        "https://www.linkedin.com/in/aaronchoi"
      ]
    };

    // Person Schema
    const personSchema = {
      "@context": "https://schema.org",
      "@type": "Person",
      "@id": "https://aaronchoi.co.uk/#person",
      "name": "Aaron Choi",
      "jobTitle": "Personal Trainer",
      "description": "BSc Sport and Exercise Science qualified personal trainer specializing in weight loss, muscle development, and body transformation.",
      "url": "https://aaronchoi.co.uk",
      "telephone": "+447787166065",
      "email": "Aaronchoi@acwellnessanddevelopment.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Hampshire",
        "addressRegion": "Hampshire",
        "addressCountry": "GB"
      },
      "hasCredential": [
        {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "degree",
          "name": "BSc Sport and Exercise Science"
        },
        {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "certification",
          "name": "Level 3 Personal Trainer"
        },
        {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "certification",
          "name": "Level 3 Exercise Referral"
        },
        {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "certification",
          "name": "Level 3 Sports and Conditioning"
        },
        {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "certification",
          "name": "Level 2 Gym Instructor"
        }
      ]
    };

    // Service Schema
    const servicesSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "Service",
          "name": "Personal Training",
          "description": "One-on-one customized training programs designed to help you reach your specific fitness goals in Hampshire.",
          "provider": {
            "@id": "https://aaronchoi.co.uk/#localbusiness"
          },
          "areaServed": {
            "@type": "State",
            "name": "Hampshire"
          },
          "serviceType": "Fitness Training"
        },
        {
          "@type": "Service",
          "name": "Sports Massage Therapy",
          "description": "Professional sports and recovery massage to enhance performance and accelerate recovery.",
          "provider": {
            "@id": "https://aaronchoi.co.uk/#localbusiness"
          },
          "areaServed": {
            "@type": "State",
            "name": "Hampshire"
          },
          "serviceType": "Massage Therapy"
        },
        {
          "@type": "Service",
          "name": "Fitness Seminars & Workshops",
          "description": "Educational seminars covering fitness, nutrition, and wellness topics with expert guest speakers.",
          "provider": {
            "@id": "https://aaronchoi.co.uk/#localbusiness"
          },
          "areaServed": {
            "@type": "State",
            "name": "Hampshire"
          },
          "serviceType": "Educational Workshop"
        },
        {
          "@type": "Service",
          "name": "Wellness Retreats",
          "description": "Immersive wellness experiences combining fitness, nutrition, mindfulness, and recovery.",
          "provider": {
            "@id": "https://aaronchoi.co.uk/#localbusiness"
          },
          "serviceType": "Wellness Program"
        }
      ]
    };

    // FAQ Schema
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "How do I get started with personal training in Hampshire?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Getting started is easy! Simply reach out through the contact form, WhatsApp, or phone. We'll schedule a free consultation to discuss your goals, assess your current fitness level, and create a personalized plan tailored to your needs."
          }
        },
        {
          "@type": "Question",
          "name": "What areas in Hampshire do you serve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "I provide personal training services across Hampshire including Southampton, Portsmouth, Winchester, Basingstoke, Eastleigh, Fareham, Andover, and Fleet. Online coaching is also available for clients outside these areas."
          }
        },
        {
          "@type": "Question",
          "name": "What qualifications do you have as a personal trainer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "I hold a BSc in Sport and Exercise Science, Level 3 Personal Trainer certification, Level 3 Exercise Referral, Level 3 Sports and Conditioning, and Level 2 Gym Instructor qualifications."
          }
        },
        {
          "@type": "Question",
          "name": "Do you offer online personal training?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes! I offer both in-person and online coaching programs. Online coaching includes customized workout plans, nutrition guidance, regular check-ins, and ongoing support through video calls and messaging."
          }
        }
      ]
    };

    // Aggregate Rating Schema
    const aggregateRatingSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Aaron Choi Personal Training",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "reviewCount": "6",
        "bestRating": "5",
        "worstRating": "5"
      }
    };

    // Breadcrumb Schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://aaronchoi.co.uk/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Services",
          "item": "https://aaronchoi.co.uk/services"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Contact",
          "item": "https://aaronchoi.co.uk/contact"
        }
      ]
    };

    // Create script elements and add to head
    const schemas = [
      localBusinessSchema,
      personSchema,
      servicesSchema,
      faqSchema,
      aggregateRatingSchema,
      breadcrumbSchema
    ];

    schemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `schema-${index}`;
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    // Cleanup on unmount
    return () => {
      schemas.forEach((_, index) => {
        const script = document.getElementById(`schema-${index}`);
        if (script) {
          document.head.removeChild(script);
        }
      });
    };
  }, []);

  return null;
};

export default SEOSchema;
